import useSWR from 'swr';
import { getSubscriptionPrice } from 'lib/shopify/subscriptionDiscount';

const fetcher = url => fetch(url).then(res => res.json());

const useSubscriptionPrice = (locale, shopifyData) => {
  const { data } = useSWR(
    shopifyData?.sellingPlans?.length
      ? `/api/shopify/get-subscription-discount/?locale=${locale}`
      : null,
    fetcher
  );

  return plan =>
    getSubscriptionPrice(parseFloat(shopifyData?.productPrice), plan, data?.discounts, shopifyData);
};

export default useSubscriptionPrice;
